import React from 'react';
import {
  renderComponentsParams,
  RequiredCarouselBaseProps,
} from './CarouselInterfaces';

const baseRenderSlideFunction = function renderSlide({
  item,
}: renderComponentsParams) {
  return <div>Slide {item.id}</div>;
};

const carouselDefaultSettings: RequiredCarouselBaseProps = {
  data: [],
  renderComponentMethod: baseRenderSlideFunction,
  isInfinite: true,
  display: {
    itemByLine: 1,
    lineBySlide: 1,
    transition: {
      rotate: {
        numberOfItemsVisible: 5,
        translationPercentage: 66,
      },
    },
  },
  classes: {
    component: 'carousel',
    custom: '',
  },
  transition: {
    type: 'fade',
    time: 300,
    easing: 'ease-out',
  },
  autoplay: {
    enabled: false,
    delay: 4000,
    pauseOnHover: true,
    percentageVisibleForAutoplay: 50,
  },
  slideList: {
    wrapper: ({ children }) => children,
  },
  controls: {
    wrapper: ({ children }) => children,
    swipe: {
      enabled: true,
      deltaForSwiping: 150,
    },
    arrows: {
      enabled: true,
      classes: {
        component: 'carousel-arrow-list',
        custom: '',
      },
      items: {
        classes: {
          component: 'carousel-arrow',
          custom: '',
        },
        children: {
          previous: null,
          next: null,
        },
      },
    },
    dots: {
      enabled: true,
      tint: null,
      classes: {
        component: 'carousel-dot-list',
        custom: '',
      },
      items: {
        classes: {
          component: 'carousel-dot',
          custom: '',
        },
        children: [],
      },
    },
  },
  events: {
    onSlideChange: null,
    afterSlideChange: null,
    onAutoplaySlideChange: null,
    afterAutoplaySlideChange: null,
    onArrowClick: null,
    afterArrowClick: null,
    onDotClick: null,
    afterDotClick: null,
    onSwipe: null,
    afterSwipe: null,
  },
};

export default carouselDefaultSettings;
